import WebTracker from '../trackers/WebTracker';
import BaseTrackerFactory from './BaseTrackerFactory';
class WebTrackerFactory extends BaseTrackerFactory {
    newTrackerInstance(namespace, appID, env, endpoint) {
        return new WebTracker(namespace, appID, env, endpoint);
    }
}
export default new WebTrackerFactory();

//# sourceMappingURL=WebTrackerFactory.js.map